module.exports = __webpack_public_path__ + "img/investment-history-white.70791154.svg";